import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'ecp-drop-down-group-menu',
    templateUrl: './drop-down-group-menu.component.html',
    styleUrls: ['./drop-down-group-menu.component.css'],
    animations: [
        trigger('displayState', [
            state('none', style({
                display: 'none', opacity: '0',
            })),
            state('block', style({
                display: 'block', opacity: '1',
            })),
            transition('none => block', animate('100ms linear')),
            transition('block => none', animate('80ms linear'))
        ])
    ]
})
export class DropDownGroupMenuComponent implements OnInit {
    changeOpen: Boolean = false;
    @Input() ecpTheme: 'default' | 'white' | 'gw-green' = 'default';
    @Input() ecpMenusList: Array<any>;
    @Input() ecpCurrentSys = 'åæ¢ç³»ç»';
    @Output() ecpNavHomeUrl = new EventEmitter();//ä¸»é¡µè·³è½¬
    @Output() ecpNavUrl = new EventEmitter();//äºçº§è·³è½¬


    navHome() {
        this.ecpNavHomeUrl.emit();
    }

    navSub(id) {
        this.ecpNavUrl.emit(id);
    }

    /*

        menusGroupList = [{
            'menuid': 96000000,
            'parentid': 0,
            'name': 'æ¶æ¯ä¸­å¿',
            'uri': '/sign',
            'iconuri': 'message',
            'havechild': true,
            'child': null,
            'introduction': 'ç»ä¸ç®¡çç³»ç»åéçé®ä»¶ï¼ç­ä¿¡ï¼å¾®ä¿¡ç­æ¥å¾ä¿¡æ¯',
            'sys_type': 'tool'
        }{
            'menuid': 96000000,
            'parentid': 0,
            'name': 'æ¶æ¯ä¸­å¿1',
            'uri': '/sign',
            'iconuri': 'message',
            'havechild': true,
            'child': null,
            'introduction': 'ç»ä¸ç®¡çç³»ç»åéçé®ä»¶ï¼ç­ä¿¡ï¼å¾®ä¿¡ç­æ¥å¾ä¿¡æ¯',
            'sys_type': 'tool'
        }{
            'menuid': 96000000,
            'parentid': 0,
            'name': 'æ¶æ¯ä¸­å¿2',
            'uri': '/sign',
            'iconuri': 'message',
            'havechild': true,
            'child': null,
            'introduction': 'ç»ä¸ç®¡çç³»ç»åéçé®ä»¶ï¼ç­ä¿¡ï¼å¾®ä¿¡ç­æ¥å¾ä¿¡æ¯',
            'sys_type': 'tool'
        }, {
            'menuid': 97000000,
            'parentid': 0,
            'name': 'å¬å±éç½®',
            'uri': '/sign',
            'iconuri': 'configuration',
            'havechild': true,
            'child': null,
            'introduction': 'éç½®é®ä»¶ãç­ä¿¡ãæ¥è¡¨ãå¾®ä¿¡ç­å¬å±ç»ä»¶æ¥å¥åæ¨¡æ¿ä¿¡æ¯',
            'sys_type': 'tool'
        }, {
            'menuid': 98000000,
            'parentid': 0,
            'name': 'ç®¡æ¼ç®¡ç',
            'uri': '/pls/management',
            'iconuri': 'pipe',
            'havechild': true,
            'child': null,
            'introduction': 'ä¸»è¦åæ¬ç®¡æ¼ç³»ç»åºæ¬ä¿¡æ¯ç»è®¡ï¼ç®¡æ¼ç¨æ·ç®¡çï¼ç®¡æ¼å®¢æ·ç®¡çï¼æµéè®¡ç®¡çç­åè½',
            'sys_type': 'sys'
        }, {
            'menuid': 99000000,
            'parentid': 0,
            'name': 'æéç®¡ç',
            'uri': '/sign',
            'iconuri': 'authority_management',
            'havechild': true,
            'child': null,
            'introduction': 'ä¸»è¦åæ¬ç»å½å¸å·ç®¡çï¼æ°´å¸ç®¡çï¼æ¥è¡¨ç»å®ï¼æå°ç»å®ï¼ç­ä¿¡æ¨¡æ¿ï¼å¬ä¼å·éç½®ç­åè½',
            'sys_type': 'sys'
        }];
    */

    constructor() {
    }

    ngOnInit() {
    }

}
